import React, { useState, useEffect, useRef } from "react";
import { InsertDriveFile, Image, PictureAsPdf, Audiotrack, Movie } from '@mui/icons-material';
import OpaqueLoading from "./opaqueLoading/opaqueLoading";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Add from "@mui/icons-material/Add";
import { Box, TextField, Typography, Autocomplete, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Card, CardContent, Button, Dialog, DialogTitle, DialogContent, DialogActions, InputLabel, MenuItem, Select, Grid, Checkbox, Stack } from "@mui/material";
const OrderForm = ({ payload, closePopup, editData, editMode, getSeriesCategory }) => {
  const [distributor, setDistributor] = useState("");
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [stockist, setStockist] = useState(null);
  const [warehouse, setWarehouse] = useState("");
  const [warehouses, setWarehouses] = useState([]);
  const [transporter, setTransporter] = useState("");
  const [attachments, setAttachment] = useState([])
  const [shippingAddress, setShippingAddress] = useState("School");
  const [billinggAddress, setBillingAddress] = useState("School");
  const [contactData, setContactData] = useState({ School: {}, Distributor: {}, Stockist: {} })
  const [remark, setRemark] = useState("");
  const [orderRemark, setOrderRemark] = useState("");
  const [updateRemark, setUpdateRemark] = useState()
  const [consentPerson, setConsentPerson] = useState("");
  const [otpOpen, setOtpOpen] = useState(false);
  const [otp, setOtp] = useState('')
  const [filteredTransporter, setFilteredTransporter] = useState([payload.transporter])
  const [sv, setSv] = useState(false);
  const [otherMobile, setOtherMobile] = useState("");
  const [otpMobile, setOtpMobile] = useState("");
  const [distributors, setDistributors] = useState([]);
  const [stockists, setStockists] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [transporters, setTransporters] = useState([]);
  const [shippingOptions, setShippingOptions] = useState(["School", "Distributor", "Stockist"]);
  const [remarks, setRemarks] = useState([]);
  // const [consentPersons,setConsentPersons] = useState(["School", "Distributor", "Stockist"]);
  const [consentPersons, setConsentPersons] = useState(["School", "Distributor"]);
  const [files, setFiles] = useState([]);
  const [open, setOpen] = useState(false);
  const [specimenDate, setSpecimenDate] = useState("");
  const [adminDate, setAdminDate] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [isDiscountAdjustment, setIsDiscountAdjustment] = useState(false);
  const [openSeriesDiscount, setOpenSeriesDiscount] = useState(false);
  const [seriesDiscountData, setSeriesDiscountData] = useState([]);
  const [specimenContactPerson, setSpecimenContactPerson] = useState("");
  const [specimenMessageOption, setSpecimenMessageOption] = useState("registered");
  const [stockistDiscount, setStockistDiscount] = useState(0);
  const [distributorType, setDistributorType] = useState("");
  const [form, setForm] = useState({
    preferredDistributorName: "",
    preferredDistributorPincode: "",
    preferredDistributorState: "",
    preferredDistributorDistrict: "",
    // preferredDistributorCity:"",
    preferredDistributorContactPersonName : "",
    preferredDistributorConsentPersonRole :"",
    preferredDistributorConsentPersonNumber :"",
    preferredDistributorEmail:"",
    preferredDistributorAddress:""
  })
  const [contactPersonRole, setContactPersonRole] = useState([]);

  const didMountRef = useRef(false);
  const isInitializingFromEditDataRef = useRef(false);


  const formatDateLocal = (d) => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }
  const today = new Date();
  const specimenMinDate = formatDateLocal(today);
  const specimenMaxDate = formatDateLocal(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 180));

  const handleFileChange = (event) => {
    setFiles([...event.target.files]);
    setOpen(true);
  };

  const getFilePreview = (file) => {
    if (file.type.startsWith('image/')) {
      return <img src={URL.createObjectURL(file)} alt={file.name} style={{ maxWidth: '100%', height: '100px' }} />;
    } else {
      return <InsertDriveFileIcon style={{ fontSize: 50, height: "100px", }} />;
    }
  };

  const getContactPersonRole = async (data) => {
    try {
      setLoading2(true)
      const results = await window.Platform.database.getContactPersonRole();
      if (results?.status) {
        setLoading2(false);
        window.NotificationUtils.showWarning("Something Went Wrong");
      }
      else {
        setContactPersonRole(results.data2)
        setLoading2(false)
      }
    }
    catch (err) {
      setLoading2(false)
      console.log(err)
    }
  }
// useEffect(() => {
//   if (editData?.adminDate) {
//     setAdminDate(editData.adminDate.split("T")[0]);
//   }
// }, [editData]);


useEffect(() => {
  if (editData?.adminDate) {
    const date = new Date(editData.adminDate);
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    setAdminDate(`${year}-${month}-${day}`);
  }
}, [editData]);
  const handleUpload = async () => {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append(`files`, file);
    });

    try {
      const response = await window.Platform.database.uploadMultipleImages(formData);
      if (response) {
        const result = await response
        const existing = Array.isArray(attachments) ? [...attachments] : [];
        result.data.files.forEach((ele) => existing.push(ele));
        setAttachment(existing)

        setOpen(false);
      } else {
        alert('Failed to upload files.');
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert('Error uploading files.');
    }
  };

  const fetchWarehouse = async (distru, s) => {
    try {
      const response = await window.Platform.database.getWarehouseinPicklist({});
      if (response && response.data) {
        setWarehouses(response.data);
        fetchTransporter(distru, s)
      } else {
        throw new Error("Failed to load warehouses");
      }
    } catch (error) {
      console.error("Error fetching warehouses:", error);
    }
  };

  function initisalise() {
    let temp = { School: {}, Distributor: {}, Stockist: {} }
    temp['School']['phone'] = payload.mobileNo
    temp['School']['email'] = payload.email
    temp['School']['address'] = payload.address
    temp['School']['id'] = payload.partyId
    temp['School']['addId'] = payload.addressId

    temp['Distributor']['phone'] = payload.mobileNo
    temp['Distributor']['email'] = payload.email
    temp['Distributor']['address'] = payload.address
    temp['Distributor']['id'] = payload.partyId
    temp['Distributor']['addId'] = payload.addressId

    
    setContactData(temp)
  }

  const getTomorrowDate = () => {
  const today = new Date();
  today.setDate(today.getDate() + 1);
  return today.toISOString().split("T")[0];
};

  const fetchDistributor = async () => {
    setLoading3(true);
    const body = { ownerId: payload.ownerId || editData?.ownerId };
    try {
      // const response = await window.Platform.database.getAllDistri(body);
      const response = await window.Platform.database.getAllOnbordedDistributors(body);
      if (response && response.data) {
        const data = response.data;
        setDistributors(data)
        if (payload.partyType == 'P6E9TGXewd') {
          setDistributor(payload?.partyId);
          setConsentPerson(["Distributor", "Stockist"])
          setShippingOptions(["Distributor", "Stockist"])

    const billing = editData?.billingDetails ? JSON.parse(editData.billingDetails) : null;

    const shipping = editData?.shippingDetails ? JSON.parse(editData.shippingDetails) : null;

  const getTypeFromId = (id) => {
      if (!id) return "School";

      const lowerId = id.toLowerCase();

      if (lowerId.startsWith("st-")) return "Stockist";
      if (lowerId.startsWith("d-")) return "Distributor";
      if (lowerId.startsWith("s-")) return "School";

      return "School";
    };

    if (billing?.billingId) {
      setBillingAddress(getTypeFromId(billing.billingId));
    }

    if (shipping?.shippingId) {
      setShippingAddress(getTypeFromId(shipping.shippingId));
    }

          // setShippingAddress("Distributor")
          // setBillingAddress("Distributor")
          setConsentPerson("Distributor")
        }
        fetchRemarks()
        fetchStockist(data)
        setLoading3(false);
      } else {
        setLoading3(false);
        throw new Error("Failed to load distributors");
      }
    } catch (error) {
      console.error("Error fetching distributors:", error);
      setLoading3(false);
    }
  };

  const getOtpConsentValue = () => {
    if (!isVerified) return "";
    
    // If schoolPreferred distributor, use preferred distributor contact number
    if (distributorType === "schoolPreferred" && payload?.partyType != "P6E9TGXewd") {
      const phone = form?.preferredDistributorConsentPersonNumber;
      if (!phone) return "";
      return `Preferred Distributor (${phone})`;
    }
    
    const person = specimenContactPerson || consentPerson || "";
    if (specimenMessageOption === "other") {
      if (!otherMobile) return "";
      return person ? `${person} (${otherMobile})` : otherMobile;
    }
    const phone = contactData?.[person]?.phone;
    if (!phone) return "";
    return `${person} (${phone})`;
  };

  const getDistributorAddressValue = (type) => {
    const normalizedType = type?.trim().toLowerCase();
    //  if(payload?.partyType != "P6E9TGXewd"){
    if (normalizedType === "distributor" && form?.preferredDistributorAddress) {
      return form.preferredDistributorAddress;
    }
    // }
    return contactData?.[type]?.addId || false;
  };

  const getDisplayAddressValue = (type) => {
    const normalizedType = type?.trim().toLowerCase();
    if (normalizedType === "distributor" && form?.preferredDistributorAddress) {
      return form.preferredDistributorAddress;
    }
    return contactData?.[type]?.address || "";
  };

  async function order(saveLater, duplicateAllowed = "no") {
    setLoading(true);
    var body = { ...payload };
    body['stockistDiscount'] = stockistDiscount;
    body['stockistId'] = stockist;
    body['distributorId'] = distributor;
    body['transport'] = transporter;
    //  body['mobileNo'] = shippingAddress.trim().toLowerCase() === "distributor" && (distributorType !== 'onboarded' && payload?.partyType != "P6E9TGXewd") ? form?.preferredDistributorConsentPersonNumber : contactData[shippingAddress]['id'];
    // body['email'] = shippingAddress.trim().toLowerCase() === "distributor" && (distributorType !== 'onboarded' && payload?.partyType != "P6E9TGXewd") ? form?.preferredDistributorEmail : contactData[shippingAddress]['email'];
    // body['address'] = getDistributorAddressValue(shippingAddress);
    // body['billingAddress'] = getDistributorAddressValue(billinggAddress);
    // body['billingMobileNo'] = billinggAddress.trim().toLowerCase() === "distributor" && (distributorType !== 'onboarded' && payload?.partyType != "P6E9TGXewd") ? form?.preferredDistributorConsentPersonNumber : contactData[billinggAddress]['phone'];
    // body['billingEmail'] = billinggAddress.trim().toLowerCase() === "distributor" && (distributorType !== 'onboarded' && payload?.partyType != "P6E9TGXewd") ? form?.preferredDistributorEmail : contactData[billinggAddress]['email'];
    body['mobileNo'] =shippingAddress.trim().toLowerCase()=="distributor"&& (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd")? form?.preferredDistributorConsentPersonNumber:contactData[shippingAddress]['id']
    body['email'] = shippingAddress.trim().toLowerCase()=="distributor"&& (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd")? form?.preferredDistributorEmail:contactData[shippingAddress]['email']
    body['address'] = shippingAddress.trim().toLowerCase()=="distributor"&& (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd")? false:contactData[shippingAddress]['addId']
    body['billingAddress'] = billinggAddress.trim().toLowerCase()=="distributor"&& (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd")? false:contactData[billinggAddress]['addId']
    body['billingMobileNo'] = billinggAddress.trim().toLowerCase()=="distributor"&& (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd")? form?.preferredDistributorConsentPersonNumber:contactData[billinggAddress]['phone']
    body['billingEmail'] = billinggAddress.trim().toLowerCase()=="distributor"&& (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd")? form?.preferredDistributorEmail:contactData[billinggAddress]['email']
    // body['otpConsent'] = consentPerson + `(${contactData[consentPerson]['phone']})`;
    const finalAttachments = (Array.isArray(payload?.attachments) && payload?.attachments.length > 0) ? payload?.attachments : (Array.isArray(attachments) && attachments.length > 0) ? attachments : parsedAttachments;
    body['attachment'] = finalAttachments
    body['saveLater'] = saveLater ? 1 : 0
    body['remark'] = remark;
    body['order_remark'] = orderRemark;
    body['warehouse'] = warehouse;
    body['attachments'] = finalAttachments;
    body['date'] = specimenDate ? Math.floor(new Date(specimenDate).getTime() / 1000) : Math.floor(Date.now() / 1000);
    body['otp_need'] = isVerified;
    body['distributorType'] = distributorType;
    body['form'] = form;
    // body['duplicateAllowed'] = duplicateAllowed; 
    body['adminDate'] = adminDate
    const otpConsent = getOtpConsentValue();
    if (isVerified && !otpConsent && editData?.otp_need != "1") {
      alert("OTP consent information is missing");
      setLoading(false);
      return;
    }
    body['otpConsent'] = otpConsent;
    // return;

    try {
      const response = await window.Platform.database.createOrder(body);

      if (response && !response.status) {
        closePopup()
        setLoading(false);
      } else {
        setLoading(false);
        window.NotificationUtils.showError(response?.message);
        throw new Error("Failed to load orders");
      }
    } catch (error) {
      console.error("Error fetching distributors:", error);
      setLoading(false);
    }
  }

  async function updateOrder() {
    setLoading(true);
    var body = { ...payload };
    body['stockistDiscount'] = stockistDiscount;
    body['stockistId'] = stockist;
    body['orderId'] = editData.orderId
    body['distributorId'] = distributor;
    body['transport'] = transporter;
    // Use Unix timestamp (seconds)
    // body['date'] = specimenDate ? Math.floor(new Date(specimenDate).getTime() / 1000) : Math.floor(Date.now() / 1000);
    body["date"] = specimenDate
      ? Math.floor(new Date(specimenDate).getTime() / 1000)
      : Math.floor(Date.now() / 1000);
    // body['date'] = Math.floor(Date.now() / 1000)
    // body['mobileNo'] =shippingAddress.trim().toLowerCase() === "distributor" && (distributorType !== 'onboarded' && payload?.partyType != "P6E9TGXewd") ? form?.preferredDistributorConsentPersonNumber : contactData[shippingAddress]['id'];
    // body['email'] = shippingAddress.trim().toLowerCase() === "distributor" && (distributorType !== 'onboarded' && payload?.partyType != "P6E9TGXewd") ? form?.preferredDistributorEmail : contactData[shippingAddress]['email'];
    // body['address'] = getDistributorAddressValue(shippingAddress);
    // body['billingAddress'] = getDistributorAddressValue(billinggAddress);
    // body['billingMobileNo'] = billinggAddress.trim().toLowerCase() === "distributor" && (distributorType !== 'onboarded' && payload?.partyType != "P6E9TGXewd") ? form?.preferredDistributorConsentPersonNumber : contactData[billinggAddress]['phone'];
    // body['billingEmail'] = billinggAddress.trim().toLowerCase() === "distributor" && (distributorType !== 'onboarded' && payload?.partyType != "P6E9TGXewd") ? form?.preferredDistributorEmail : contactData[billinggAddress]['email'];
    body['mobileNo'] =shippingAddress.trim().toLowerCase()=="distributor"&& (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd")? form?.preferredDistributorConsentPersonNumber:contactData[shippingAddress]['id']
    body['email'] = shippingAddress.trim().toLowerCase()=="distributor"&& (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd")? form?.preferredDistributorEmail:contactData[shippingAddress]['email']
    body['address'] = shippingAddress.trim().toLowerCase()=="distributor"&& (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd")? false:contactData[shippingAddress]['addId']
    body['billingAddress'] = billinggAddress.trim().toLowerCase()=="distributor"&& (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd")? false:contactData[billinggAddress]['addId']
    body['billingMobileNo'] = billinggAddress.trim().toLowerCase()=="distributor"&& (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd")? form?.preferredDistributorConsentPersonNumber:contactData[billinggAddress]['phone']
    body['billingEmail'] = billinggAddress.trim().toLowerCase()=="distributor"&& (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd")? form?.preferredDistributorEmail:contactData[billinggAddress]['email']
    body['approvalStatus'] = editData.approvalStatus
    const finalAttachments = (Array.isArray(payload?.attachments) && payload?.attachments.length > 0) ? payload?.attachments : (Array.isArray(attachments) && attachments.length > 0) ? attachments : parsedAttachments;
    body['attachment'] = finalAttachments;
    body['remark'] = remark;
    body['order_remark'] = orderRemark;
    // body['seriesDiscount'] = body?.seriesDiscount || editData?.seriesDiscount || "";
    body['warehouse'] = warehouse;
    body['attachments'] = finalAttachments;
    body['updateRemark'] = updateRemark
    body['soID'] = editData.so_id
    body['otp_need'] = editData?.isVerified;
    body['distributorType'] = distributorType;
    body['form'] = distributorType=='' ||!distributorType?{}: form;
    body["rmAddedDistributor"] = editData?.rmAddedDistributor;
    body['adminDate'] = adminDate;
    const otpConsent = editData?.otpConsent ? editData?.otpConsent : getOtpConsentValue();

    if (isVerified && !otpConsent && editData?.otp_need != "1") {
      alert("OTP consent information is missing");
      setLoading(false);
      return;
    }
    body['otpConsent'] = otpConsent;
    // return;

    try {
      const response = await window.Platform.database.updateOrderDetails(body);
      if (response && !response.status) {
        closePopup();
        setLoading(false);
      } else {
        setLoading(false);
        throw new Error("Failed to load orders");
      }
    } catch (error) {
      console.error("Error fetching distributors:", error);
      setLoading(false);
    }
  }

  // async function verifyOtp() {
  //   const body = { mobile: contactData[consentPerson]['phone'], otp: otp };
  //   try {
  //     const response = await window.Platform.database.verifyOtp(body);
  //     if (response && !response.status) {
  //       console.log(response)
  //       order(sv)
  //     } else {
  //       throw new Error("Failed to load orders");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching distributors:", error);
  //   }
  // };
  async function verifyOtp() {
    const body = {
      mobile: otpMobile, // SAME mobile as sendOtp
      otp: otp
    };
    try {
      const response = await window.Platform.database.verifyOtp(body);
      if (response && !response.status) {
        if (editMode) {
          updateOrder();
        } else {
          order(sv);
        }
        // order(sv);
        setOtpOpen(false);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const fetchTransporter = async (d, s) => {
    const body = {};
    try {
      const response = await window.Platform.database.getTransporters(body);

      if (response && response.data) {
        const data = response.data;

        setTransporters(data);
        if (editMode) {
          setTimeout(() => {
            editPrevious(d, s)
          }, 200)
        }
      } else {
        throw new Error("Failed to load transporters");
      }
    } catch (error) {
      console.error("Error fetching transporters:", error);
    }
  };

  function editPrevious(d, s) {
    setStockist(editData?.stockistId || "")
    setDistributor(editData?.distributorIDforSchool ? editData?.distributorIDforSchool : (form?.preferredDistributorConsentPersonNumber || ""))
    setWarehouse(editData?.warehouse || "")
    const distId = editData?.distributorIDforSchool;
    const selected = Array.isArray(d) ? d.find(ele => ele.distributorID == distId) : null;

    const stokId = editData?.stockistId;
    const selectedS = Array.isArray(s) ? s.find(ele => ele.stockistID == stokId) : null;

    const tempContactData = { School: {}, Distributor: {}, Stockist: {} };
    const fil = [payload.transporter];

    if (selected?.transporterId) fil.push(selected.transporterId);
    if (selectedS?.transporterId) fil.push(selectedS.transporterId);

   if(payload?.partyType != "P6E9TGXewd"){
     tempContactData['Distributor']['phone'] = selected?.makerContact || "";
    tempContactData['Distributor']['email'] = selected?.email || "";
    tempContactData['Distributor']['address'] = formatAddress(selected || {});
    tempContactData['Distributor']['id'] = selected?.distributorID || "";
    tempContactData['Distributor']['addId'] = selected?.addressId || "";
   }
   else{
      tempContactData['Distributor']['phone'] = payload.mobileNo || "";
    tempContactData['Distributor']['email'] = payload.email || "";
    tempContactData['Distributor']['address'] = payload.address || "";
    tempContactData['Distributor']['id'] = payload.partyId || "";
    tempContactData['Distributor']['addId'] = payload?.addressId || "";
   }
    tempContactData['School']['phone'] = payload.mobileNo || "";
    tempContactData['School']['email'] = payload.email || "";
    tempContactData['School']['address'] = payload.address || "";
    tempContactData['School']['id'] = payload.partyId || "";
    tempContactData['School']['addId'] = payload.addressId || "";
    
    tempContactData['Stockist']['phone'] = selectedS?.makerContact || "";
    tempContactData['Stockist']['email'] = selectedS?.email || "";
    tempContactData['Stockist']['address'] = formatAddress(selectedS || {});
    tempContactData['Stockist']['id'] = selectedS?.stockistID || "";
    tempContactData['Stockist']['addId'] = selectedS?.addressId || "";

    setFilteredTransporter(fil.filter((ele, idx) => ele && fil.indexOf(ele) === idx));
    setContactData(tempContactData);
    setTransporter(editData?.Transport || "");
    setOrderRemark(editData?.order_remark || "");
    setUpdateRemark(editData?.updateRemark || "");
    if(payload?.orderType == "Specimen"){
      setRemark(editData?.order_remark || "");
    }
    else{
      setRemark(editData?.remark || "");
    }
  }
  const fetchRemarks = async () => {
    const body = {};
    try {
      const response = await window.Platform.database.getRemarkInPicklist(body);
      if (response && response.data) {
        setRemarks(response.data);
      } else {
        throw new Error("Failed to load remarks");
      }
    } catch (error) {
      console.error("Error fetching remarks:", error);
    }
  };

  const fetchStockist = async (distru) => {
    setLoading1(true);
    const body = { pageNumber: 0 };
    try {
      const response = await window.Platform.database.getStockistAll(body);
      if (response && response.data) {
        setStockists(response.data);
        fetchWarehouse(distru, response.data);
        setLoading1(false);
      } else {
        setLoading1(false);
        throw new Error("Failed to load orders");
      }
    } catch (error) {
      setLoading1(false);
      console.error("Error fetching stockists:", error);
    }
  };

  const formatDateForInput = (dateValue) => {
    if (!dateValue) return "";
    let d;
    if (typeof dateValue === "string") {
      d = new Date(dateValue);
    } else if (typeof dateValue === "number") {
      d = new Date(dateValue * 1000);
    }
    if (!d || isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };
useEffect(() => {
  if (editMode && hasAdditionalDiscount(editData?.additionalDiscount)) {
    setIsDiscountAdjustment(true);
  }
    setOrderRemark(editData?.order_remark  || "")
    setUpdateRemark(editData?.updateRemark || "")
}, [editMode, editData]);


  useEffect(() => {
    if (editMode) {
      setStockist(editData?.stockistId || "")
      setConsentPersons(["School", "Distributor", "Stockist"]);
    } else {
      setConsentPersons(["School", "Distributor"]);
    }
  }, [editMode]);

  useEffect(() => { 
    setDistributor("");
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    if (isInitializingFromEditDataRef.current) {
      isInitializingFromEditDataRef.current = false;
      return;
    }
    setForm({
      preferredDistributorName: "",
      preferredDistributorPincode: "",
      preferredDistributorState: "",
      preferredDistributorDistrict: "",
      preferredDistributorContactPersonName: "",
      preferredDistributorConsentPersonRole: "",
      preferredDistributorConsentPersonNumber: "",
      preferredDistributorEmail: "",
      preferredDistributorAddress: ""
    });

    // re-initialize contact data based on payload
    try {
      initisalise();
    } catch (e) {
      // noop
    }
  }, [distributorType]);

  useEffect(() => {
    if (!editMode && specimenContactPerson === "Stockist") {
      setSpecimenContactPerson("");
    }
  }, [editMode]);


  useEffect(() => {
    if (editMode && editData) {
      // Set flag to skip reset in distributorType effect during initialization
      isInitializingFromEditDataRef.current = true;

      setIsVerified(!!editData?.otp_need);

      // Optional: if you store otpConsent like "School (9876543210)"
      if (editData?.otpConsent) {
        setSpecimenContactPerson(
          editData.otpConsent.split("(")[0]?.trim() || ""
        );
      }
      if (editData?.distributorType) {
        setDistributorType(editData.distributorType);
      }

      if (editData?.form) {
        const parsedForm = typeof editData.form === 'string'
          ? (function () { try { return JSON.parse(editData.form); } catch { return {}; } })()
          : editData.form;
        setForm(prev => ({ ...prev, ...parsedForm }));
      } else {
        const mapped = {};
        if (editData?.distributorNameforSchool) mapped.preferredDistributorName = editData.distributorNameforSchool;
        if (editData?.preferredDistributorPincode) mapped.preferredDistributorPincode = editData.preferredDistributorPincode;
        if (editData?.preferredDistributorState) mapped.preferredDistributorState = editData.preferredDistributorState;
        if (editData?.preferredDistributorDistrict) mapped.preferredDistributorDistrict = editData.preferredDistributorDistrict;
        if (editData?.preferredDistributorContactPersonName) mapped.preferredDistributorContactPersonName = editData.preferredDistributorContactPersonName;
        if (editData?.preferredDistributorConsentPersonRole) mapped.preferredDistributorConsentPersonRole = editData.preferredDistributorConsentPersonRole;
        if (editData?.preferredDistributorConsentPersonNumber) mapped.preferredDistributorConsentPersonNumber = editData.preferredDistributorConsentPersonNumber;
        if (editData?.preferredDistributorEmail) mapped.preferredDistributorEmail = editData.preferredDistributorEmail;
        if (editData?.preferredDistributorAddress) mapped.preferredDistributorAddress = editData.preferredDistributorAddress;
        if (Object.keys(mapped).length) setForm(prev => ({ ...prev, ...mapped }));
      }
    }
  }, [editMode, editData]);

  useEffect(() => {
    if (editData?.date) {
      setSpecimenDate(formatDateForInput(editData.date));
    }
    if (!editData) return;

  try {
    const billing = editData?.billingDetails
      ? JSON.parse(editData.billingDetails)
      : null;

    const shipping = editData?.shippingDetails
      ? JSON.parse(editData.shippingDetails)
      : null;

    const getTypeFromId = (id) => {
      if (!id) return "School";

      const lowerId = id.toLowerCase();

      if (lowerId.startsWith("st-")) return "Stockist";
      if (lowerId.startsWith("d-")) return "Distributor";
      if (lowerId.startsWith("s-")) return "School";

      return "School";
    };

    if (billing?.billingId) {
      setBillingAddress(getTypeFromId(billing.billingId));
    }

    if (shipping?.shippingId) {
      setShippingAddress(getTypeFromId(shipping.shippingId));
    }

  } catch (err) {
    console.error("Error parsing address data", err);
  }
  }, [editData]);

  useEffect(() => {
    getContactPersonRole();
    initisalise()
    fetchDistributor()
  }, [])

  useEffect(() => {
    if (!isVerified) {
      setSpecimenContactPerson("");
      setSpecimenMessageOption("registered");
      setOtherMobile("");
      setOtp("");
      setOtpMobile("");
    }
  }, [isVerified]);

  function formatAddress(addressData) {
    let addressLine1 = addressData['AddressLine1'] ?? '';
    // let addressLine1 = addressData['AddressLine1'] ?? addressData['Address'] ?? '';
    let addressLine2 = addressData['AddressLine2'] ?? '';
    let state = addressData['State'] ?? '';
    let pincode = addressData['Pincode'] ?? '';
    let addressParts = [
      addressLine1,
      // addressLine2,
      // state,
      // pincode,
      addressLine2 ? addressLine2 : "",
      state ? state : "",
      pincode ? pincode : "",
    ];
     return addressParts.join(', ');
    // return addressParts.filter(part => part && String(part).trim()).join(', ');
  }

  function selectDistributor(value, op) {
    setDistributor(value)

    let a = value

    let selected = distributors.filter((ele) => {
      return ele.distributorID == a
    })[0];
    let temp = { ...contactData }
    let fil = [...filteredTransporter]
    fil.push(selected?.transporterId)

    temp['Distributor']['phone'] = selected?.makerContact
    temp['Distributor']['email'] = selected?.email
    temp['Distributor']['address'] = formatAddress(selected ? selected : {})
    temp['Distributor']['id'] = value
    temp['Distributor']['addId'] = selected.addressId
    setFilteredTransporter(fil)
    setContactData(temp)
    // if(payload?.partyType != "P6E9TGXewd"){
    //   console.log("Nahi aana chahiye")
    //   setContactData(temp)
    // }
  }

  function selectStockist(value) {
    setStockist(value)
    let a = value
    let selected = stockists.filter((ele) => {
      return ele.stockistID == a
    })[0];
    let temp = { ...contactData }
    let fil = [...filteredTransporter]
    fil.push(selected.transporterId)

    temp['Stockist']['phone'] = selected.makerContact
    temp['Stockist']['email'] = selected.email
    temp['Stockist']['address'] = formatAddress(selected)
    temp['Stockist']['id'] = value
    temp['Stockist']['addId'] = selected.addressId
    setFilteredTransporter(fil.filter((ele, index) => { return ele && fil.indexOf(ele) == index }))
    setContactData(temp)
  }

  function getNameByID(t) {
    return transporters.filter(ele => ele.transporterId == t)[0]?.transporter_name
  }

  const getOtpMobile = () => {
    if (!isVerified) return "";
    
    if (distributorType === "schoolPreferred") {
      return form?.preferredDistributorConsentPersonNumber || "";
    }
    
    if (specimenMessageOption === "registered") {
      const person = specimenContactPerson || consentPerson || "";
      const phoneFromData = contactData?.[person]?.phone;
      if (phoneFromData) return phoneFromData;
      if (person === "Distributor") {
        const sel = distributors.find(d => d.distributorID == distributor);
        if (sel) return sel.makerContact || sel?.makerContact || "";
      }
      if (person === "Stockist") {
        const sel = stockists.find(s => s.stockistID == stockist);
        if (sel) return sel.makerContact || sel?.makerContact || "";
      }
      return "";
    }
    if (specimenMessageOption === "other") {
      return otherMobile;
    }
    return "";
  };

  const isPreferredDistributorFormInvalid = () => {
  return (
    !form.preferredDistributorName ||
    // !form.preferredDistributorPincode ||
    // !form.preferredDistributorState ||
    // !form.preferredDistributorDistrict ||
    // !form.preferredDistributorCity ||
    // !form.preferredDistributorContactPersonName ||
    // !form.preferredDistributorConsentPersonRole ||
    // !form.preferredDistributorConsentPersonNumber ||
    // !form.preferredDistributorEmail || 
    !form.preferredDistributorAddress
  );
};


  async function proceedToOrder(flag) {
   if(payload?.orderType != "Specimen"){
     if(!distributorType && payload?.partyType != "P6E9TGXewd"){
      alert("Please Select Distributor Type");
      return;
    }
     if(payload?.orderProcess != "upload" && payload?.orderType?.toLowerCase() != "specimen" && (distributorType == "schoolPreferred" && isPreferredDistributorFormInvalid())) {
        alert(" Please fill form correctly ");
        return;
      }
      if(distributorType == "onboarded" && !distributor && payload?.partyType != "P6E9TGXewd"){
        alert(" Please Select Distributor ");
        return;
      }
   }
  //  if(payload?.orderType === "Specimen" && payload?.orderProcess != "upload" && (attachments == "" || !(editData?.attachment))){
  //   alert("Attachment");
  //   return;
  //  }
    setSv(flag);
    if (editMode) {
      // if(distributorType == "schoolPreferred" && ( !stockist || stockist == null)){
      //    alert("Please Select Stockist");
      //   return;
      // }
      if (!updateRemark || updateRemark === "" || updateRemark === undefined) {
        alert("Please enter update remark");
        return;
      }
      else if (updateRemark?.length < 20) {
        alert("Update remark should be at least 20 characters long");
        return;
      }
     
      // If OTP was already verified in previous request, skip OTP and call update API directly
      if (editData?.otp_need == "1") {
        updateOrder();
        return;
      }
      
      if (!isVerified) {
        updateOrder();
        return;
      }
      const mobile = getOtpMobile();
      if (!mobile) {
        alert("Please enter valid mobile number");
        return;
      }
      setOtpMobile(mobile);
      const body = { mobile };
      try {
        const response = await window.Platform.database.sendOtp(body);
        if (response && !response.status) {
          setOtpOpen(true);
        }
        else {
          window.NotificationUtils.showError(response?.message, mobile || "Failed to send OTP. Please try again.");
        }
      } catch (error) {
        console.error(error);
        window.NotificationUtils.showError(mobile, "Failed to send OTP. Please try again.");

      }
      // updateOrder();
      return;
    }
    if(payload?.orderType == "Specimen") {
      if(remark.trim() === ""){
      alert("Please enter remark for specimen order");
      return;
      }
      else if(remark.trim().length < 20){
      alert("Remark for specimen order should be at least 20 characters long");
      return;
      }
    }
    else{
        if(distributorType == "schoolPreferred" && ( !stockist || stockist == null)){
         alert("Please Select Stockist");
        return;
      }
      if(orderRemark === "" || orderRemark === undefined){
      alert("Please enter order remark");
      return;
    }
    else if(orderRemark.length < 20){
      alert("Order remark should be at least 20 characters long");
      return;
    }
    }
      if (payload?.orderProcess != "upload") {
      const noAttachments = !(Array.isArray(attachments) && attachments.length > 0) && !(parsedAttachments && parsedAttachments.length > 0);
      if (noAttachments) {
        alert("Please upload attachment(s) before placing the order.");
        return;
      }
    }
    
    // If OTP was already verified in previous request, skip OTP and call order API directly
    if (editData?.otp_need == "1") {
      order(flag);
      return;
    }
    if (!isVerified) {
      order(flag);
      return;
    }
    const mobile = getOtpMobile();
    if (!mobile) {
      alert("Please enter valid mobile number");
      return;
    }
    setOtpMobile(mobile);
    const body = { mobile };
    try {
      const response = await window.Platform.database.sendOtp(body);
      if (response && !response.status) {
        setOtpOpen(true);
      }
      else {
        window.NotificationUtils.showError(response?.message, mobile || "Failed to send OTP. Please try again.");
      }
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError(mobile, "Failed to send OTP. Please try again.");
    }
  }

  function handleSeriesDiscountChange(seriesId, value) {
    const entered = Number(value) || 0;

    setSeriesDiscountData(prev =>
      prev.map(item => {
        if (item.seriesId !== seriesId) return item;

        if (entered > item.remaining) {
          window.NotificationUtils.showError(
            `You already gave ${item.alreadyGiven}%, remaining is ${item.remaining}% for ${item.seriesName}. Overall limit is ${item.maxAllowed}%`
          );
          return item;
        }

        return {
          ...item,
          additional: entered
        };
      })
    );
  }

  // function handleAdditionalDiscount() {
  //   console.log(payload, "payload<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<", editData, "eidtData<<<<<<<<<<<<<<<<<<<<<<<<")
  //   const preparedData = getSeriesCategory
  //     .filter(s => payload.seriesDiscount?.[s.seriesTableId] !== undefined)
  //     .map(series => {
  //       const alreadyGiven = payload.seriesDiscount[series.seriesTableId] || 0;
  //       const maxAllowed = Number(series.maxDiscount) || 0;

  //       return {
  //         seriesId: series.seriesTableId,
  //         seriesName: series.seriesName,
  //         alreadyGiven,
  //         maxAllowed,
  //         remaining: Math.max(maxAllowed - alreadyGiven, 0),
  //         additional: 0
  //       };
  //     });
  //   setSeriesDiscountData(preparedData);
  //   setOpenSeriesDiscount(true);
  // }
//     const parseAdditionalDiscount = (val) => {
//   if (!val) return {};
//   if (typeof val === "object") return val;
//   try {
//     return JSON.parse(val);
//   } catch (e) {
//     return {};
//   }
// };
const parseAdditionalDiscount = (val) => {
  if (!val) return {};
  try {
    return typeof val === "string" ? JSON.parse(val) : val;
  } catch {
    return {};
  }
};

const hasAdditionalDiscount = (val) => {
  const parsed = parseAdditionalDiscount(val);
  return Object.keys(parsed).length > 0;
};


  function handleAdditionalDiscount() {
  const existingAdditional = editMode
    ? parseAdditionalDiscount(editData?.additionalDiscount)
    : {};

  const preparedData = getSeriesCategory
    .filter(s => payload.seriesDiscount?.[s.seriesTableId] !== undefined)
    .map(series => {
      const alreadyGiven = payload.seriesDiscount[series.seriesTableId] || 0;
      const maxAllowed = Number(series.maxDiscount) || 0;

      return {
        seriesId: series.seriesTableId,
        seriesName: series.seriesName,
        alreadyGiven,
        maxAllowed,
        remaining: Math.max(maxAllowed - alreadyGiven, 0),
        // ✅ PREFILL FROM EDIT DATA
        additional: existingAdditional?.[series.seriesTableId] || 0
      };
    });

  setSeriesDiscountData(preparedData);
  setOpenSeriesDiscount(true); // opens ONLY on click
}


  function applyAdditionalDiscount() {
    const additionalDiscount = {};

    seriesDiscountData.forEach(item => {
      if (item.additional > 0) {
        additionalDiscount[item.seriesId] = item.additional;
      }
    });

    payload.additionalDiscount = additionalDiscount;

    setOpenSeriesDiscount(false);
  }

  // const getStockistHelperText = () => {
  //   if (!payload?.totalAmount || !stockistDiscount) {
  //     return "Enter discount percentage";
  //   }

  //   const discountValue =
  //     (payload.totalAmount * stockistDiscount) / 100;

  //   return `₹${discountValue.toFixed(2)} will be discounted from total order value`;
  // };

  const parsedAttachments = React.useMemo(() => {
    const raw = editData?.attachment;
    if (!raw) return [];

    let parsed = raw;
    if (typeof raw === "string") {
      try {
        parsed = JSON.parse(raw);
      } catch (err) {
        console.error("Invalid attachments JSON", err);
        return [];
      }
    }

    if (Array.isArray(parsed)) return parsed;

    // Common API shape: { files: [...] }
    if (parsed && typeof parsed === "object" && Array.isArray(parsed.files)) return parsed.files;

    // Single file object -> wrap in array
    if (parsed && typeof parsed === "object" && (parsed.fileName || parsed.originalName || parsed.url)) return [parsed];

    return [];
  }, [editData?.attachment]);
  
  const handleImageClick = (file) => {
    const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
    window.open(url, "_blank");
  };

  const handlePdfClick = (file) => {
    const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
    window.open(url, "_blank");
  };

  const downloadFile = async (file) => {
    const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;

    try {
      const response = await fetch(url);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = file.originalName || file.fileName || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };
  
const changeHandler = (fieldName, value) => {
  setForm((prevForm) => ({
    ...prevForm,
    [fieldName]: value,
  }));
};

 const fetchPinCode = async (pincode) => {
  try {
    setLoading(true);

    const results = await window.Platform.database.fetchPinCode(pincode);

    if (results?.status) {
      setLoading(false);
      window.NotificationUtils.showWarning("Something went wrong");
    } else {
      setForm((prev) => ({
        ...prev,
        preferredDistributorState: results?.data?.[0]?.StateName || "",
        preferredDistributorDistrict: results?.data?.[0]?.District || "",
        // preferredDistributorCity: results?.data?.[0]?.City || "",
      }));
      setLoading(false);
    }
  } catch (err) {
    setLoading(false);
    console.error(err);
  } 
};

  return (
    <Box sx={{ p: 3, maxWidth: 500, mx: "auto" }}>
      {loading && <OpaqueLoading />}
      {loading1 && <OpaqueLoading />}
      {loading2 && <OpaqueLoading />}
      {loading3 && <OpaqueLoading />}
      {payload?.orderType === "Specimen" ? (
        <Box>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            Specimen Order Details
          </Typography>
          {payload?.orderType === "Specimen" && payload?.orderProcess != "upload" &&
            <>
              <Card sx={{ mt: 2, p: 2, width: '100%' }}  fullWidth maxWidth="sm">
                <FormLabel>Upload Attachments</FormLabel>
                <input type="file" multiple onChange={handleFileChange} />
                <Dialog open={open} onClose={() => setOpen(false)}  fullWidth maxWidth="sm">
                  <DialogTitle>File Preview</DialogTitle>
                  <DialogContent>
                    <Grid container spacing={2}>
                      {files.map((file, index) => (
                        <Grid item xs={6} key={index}>
                          {getFilePreview(file)}
                          <Typography variant="body2" noWrap>{file.name}</Typography>
                        </Grid>
                      ))}
                    </Grid>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={handleUpload} variant="contained" color="primary">Upload</Button>
                  </DialogActions>
                </Dialog>
              </Card>
            </>
          }
          {editMode && payload?.orderType === "Specimen" &&  <Grid container spacing={3} sx={{ mt: 1 }}>
                {parsedAttachments && parsedAttachments?.map((file, index) => {
                  const isImage = /\.(jpg|jpeg|png|gif)$/i.test(file.fileName);
                  const isPDF = /\.pdf$/i.test(file.fileName);

                  return (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <Card
                        elevation={3}
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          borderRadius: 2,
                        }}
                      >
                        {/* Preview */}
                        <Box
                          sx={{
                            height: 160,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#f5f5f5",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            isPDF ? handlePdfClick(file) : handleImageClick(file)
                          }
                        >
                          {isImage ? (
                            <img
                              src={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                              alt={file.originalName}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <InsertDriveFileIcon sx={{ fontSize: 60, color: "#666" }} />
                          )}
                        </Box>

                        {/* File Info */}
                        <CardContent sx={{ p: 1.5 }}>
                          <Typography
                            variant="body2"
                            title={file.originalName}
                            sx={{
                              fontWeight: 500,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {file.originalName}
                          </Typography>
                        </CardContent>

                        {/* Actions */}
                        <Box sx={{ p: 1.5, pt: 0 }}>
                          <Button
                            fullWidth
                            size="small"
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              downloadFile(file);
                            }}
                          >
                            Download
                          </Button>
                        </Box>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>}
          <TextField
           sx={{ color: "#000", fontWeight: 500, fontSize: "14px", mt: 2 }}
            label="Remark"
            multiline
            rows={3}
            fullWidth
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
            {editMode && <TextField
            label="Update Remark"
             sx={{ color: "#000", fontWeight: 500, fontSize: "14px", mt: 2 }}
            fullWidth
            value={updateRemark}
            onChange={(e) => setUpdateRemark(e.target.value)}
          />}
        </Box>
      ) : (
        <Box style={{ width: "100%" }}>
          {editMode && payload?.partyType != "P6E9TGXewd" && <Button fullWidth variant="outlined" color = {editData?.distributorType == "schoolPreferred" ? "error" : "success"} sx={{fontSize:"14px"}}>
            RM Added Distributor : - {editData?.rmAddedDistributorName + " - " + editData?.rmAddedDistributor}
          </Button>}
            {payload?.partyType != "P6E9TGXewd" && <FormControl fullWidth className="my-2">
              <InputLabel  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }}>Select Distributor Type</InputLabel>
              <Select
               sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }}
                value={distributorType}
                label="Select Distributor Type"
                onChange={(e) => setDistributorType(e.target.value)}
              >
                <MenuItem  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }} value="">Select</MenuItem>
                <MenuItem  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }} value="onboarded">Onboarded Distributor</MenuItem>
                <MenuItem  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }} value="schoolPreferred">School Preferred Distributor</MenuItem>
              </Select>
            </FormControl>}

            {distributorType === "onboarded"  && (
              <FormControl fullWidth className="my-2">
                <InputLabel  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }}>Select Distributor</InputLabel>
                <Select
                 sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }}
                  value={distributor}
                  label="Select Distributor"
                  // disabled={payload.partyType === "P6E9TGXewd"}
                  onChange={(e) => selectDistributor(e.target.value)}
                >
                  {distributors.map((option, index) => (
                    <MenuItem  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }}
                     key={index} value={option?.distributorID}>
                      {option?.DistributorName} - {option?.distributorID}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) }
             {distributorType == "schoolPreferred" && payload?.partyType != "P6E9TGXewd" && (
              <div style={{
                    backgroundColor: "#c2a7a747",
                    padding: "20px",
              }}>
                <TextField
                required
                  label="Preferred Distributor Name"
                  fullWidth
                  size="small"
                  sx={{ mt: 2 }}
                  value={form?.preferredDistributorName || ""}
                  onChange={(e) =>
                    changeHandler("preferredDistributorName", e.target.value)
                  }
                />
                <TextField
                    sx={{ mt: 2 }}
                    label="Address "
                    fullWidth
                    required
                    size="small"
                    value={form?.preferredDistributorAddress || ""}
                    onChange={(e) => {
                      changeHandler("preferredDistributorAddress", e.target.value);
                    }}
                  />
                  <TextField
                    sx={{ mt: 2 }}
                    label="Pincode"
                    fullWidth
                    // required
                    size="small"
                    value={form?.preferredDistributorPincode || ""}
                    onChange={async (e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 6);
                      changeHandler("preferredDistributorPincode", value);
                      if (value.length === 6) {
                        fetchPinCode(value);
                      }
                    }}
                  />
                  <TextField
                  
                  sx={{ mt: 2 }}
                    label="State"
                    fullWidth
                    size="small"
                    disabled
                    value={form?.preferredDistributorState || ""}
                  />
                  <TextField
                  
                  sx={{ mt: 2 }}
                    label="District"
                    fullWidth
                    size="small"
                    disabled
                    value={form?.preferredDistributorDistrict || ""}
                  />
                <TextField
                
                  label="Contact Person Name"
                  fullWidth
                  size="small"
                  sx={{ mt: 2 }}
                  value={form?.preferredDistributorContactPersonName || ""}
                  onChange={(e) =>
                    changeHandler("preferredDistributorContactPersonName", e.target.value)
                  }
                />
                  <FormControl  fullWidth size="small" sx={{ mt: 2 }}
                            variant="outlined">
                            <InputLabel sx={{ color: "black", fontWeight: "500" }} >Decision Maker Role</InputLabel>
                            <Select
                            
                              labelId={`Product`}
                              label="Decision Maker Role"
                              sx={{ color: "black", fontWeight: "500" }}
                              value={form?.preferredDistributorConsentPersonRole || ""}
                              onChange={(e) => changeHandler("preferredDistributorConsentPersonRole", e.target.value)}
                            >
                              {contactPersonRole?.map((option, optionIndex) => (
                                <MenuItem key={option?.contactPersonRoleId} value={option?.contactPersonRoleId} sx={{ color: "black", fontWeight: "500" }}>
                                  {option?.roleName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                <TextField
                
                  label="Contact Number"
                  fullWidth
                  size="small"
                  sx={{ mt: 2 }}
                  inputProps={{ maxLength: 10 }}
                  value={form?.preferredDistributorConsentPersonNumber || ""}
                  onChange={(e) =>
                    changeHandler(
                      "preferredDistributorConsentPersonNumber",
                      e.target.value.replace(/[^0-9]/g, "")
                    )
                  }
                />
                <TextField
                
                  label="Email Address"
                  fullWidth
                  size="small"
                  sx={{ mt: 2 }}
                  value={form?.preferredDistributorEmail || ""}
                  onChange={(e) =>
                    changeHandler("preferredDistributorEmail", e.target.value)
                  }
                />
              </div>
            )}

       {/* <FormControl fullWidth className="my-2">
        <InputLabel shrink={!!stockist} sx={{ color: "#000", fontWeight: "500", fontSize: "14px" }} > Select Stockist </InputLabel>
            <Select  sx={{ color: "#000", fontWeight: "500", fontSize:"14px" }} value={stockist} label={"Select Stockist"} onChange={(e) => selectStockist(e.target.value)}>
              {stockists.map((option, i) => (
                <MenuItem sx={{ color: "#000", fontWeight: "500", fontSize:"14px" }} key={i} value={option?.stockistID}>{option?.StockistName}</MenuItem>
              ))}
            </Select>
          </FormControl> */}
       {payload?.partyType != "P6E9TGXewd" && <hr style={{width:"100%", color:"#000", fontSize:"14px", borderTop:"1px solid #000" }}/>}

<FormControl fullWidth variant="outlined" className="my-2">
  <InputLabel
    id="stockist-label"
    sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }}
  >
    Select Stockist
  </InputLabel>

  <Select
    labelId="stockist-label"
    value={stockist || ""}
    label="Select Stockist"
    onChange={(e) => selectStockist(e.target.value)}
    sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }}
  >
    {stockists.map((option, i) => (
      <MenuItem
       sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }}
        key={i}
        value={option?.stockistID}
      >
        {option?.StockistName}
      </MenuItem>
    ))}
  </Select>
</FormControl>
 <FormControl fullWidth className="my-2">
              <InputLabel  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }}>{"Select Warehouse"}</InputLabel>
              <Select  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }} value={warehouse}  label={"Select Warehouse"} onChange={(e)=>setWarehouse(e.target.value)}>
                  <MenuItem  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }} key={"12qwq1"} value="">Select Warehouse</MenuItem>
                {warehouses.map((option, i) => (
                  <MenuItem  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }} key={i} value={option?.id}>{option?.name}</MenuItem>
                ))}
              </Select>
              </FormControl>
         
        <FormControl fullWidth className="my-2">
              <InputLabel  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }}>{"Select Transporter"}</InputLabel>
           <Select  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }} value={transporter}  label={"Select Transporter"} onChange={(e)=>setTransporter(e.target.value)}>
                  <MenuItem  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }} key={"12qwq1"} value="">Select Transporter</MenuItem>
                {transporters.map((option, i) => (
                  <MenuItem  sx={{ color: "#000", fontWeight: 500, fontSize: "14px" }} key={i} value={option?.transporterId}>{option?.transporter_name}</MenuItem>
                ))}
              </Select>
        </FormControl>
        <hr style={{width:"100%", color:"#000", fontSize:"14px", borderTop:"1px solid #000" }}/>
        <Card sx={{ mt: 2, p: 2 }}>
        {/*  <FormControl>
         <FormLabel sx={{fontSize:"14px", fontWeight:"600"}}>Bill To: - </FormLabel>
          <RadioGroup
            value={billinggAddress}
            onChange={(e) => setBillingAddress(e.target.value)}
          >
            {shippingOptions.map((option) => (
              <FormControlLabel key={option} value={option} control={<Radio />} label={option} />
            ))}
          </RadioGroup>
        </FormControl> */}
              <FormControl sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <FormLabel sx={{ fontSize: "14px", fontWeight: 600, mr: 2, color:"#000" }}>
                  Bill To: -
                </FormLabel>

                <RadioGroup
                  row
                  value={billinggAddress}
                  onChange={(e) => setBillingAddress(e.target.value)}
                >
                  {shippingOptions.map((option) => (
                    <FormControlLabel
                      key={option}
                      value={option}
                      control={<Radio size="small" />}
                      label={option}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              <TextField label="Address" value={billinggAddress.trim().toLowerCase()=="distributor"&& (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd") ? form?.preferredDistributorAddress:contactData[billinggAddress]['address'] || ""} variant="outlined"  InputLabelProps={{ shrink: true }}  fullWidth sx={{ mt: 1 }} disabled />
        {/* <TextField label="Address" value={getDisplayAddressValue(billinggAddress)} variant="outlined" InputLabelProps={{ shrink: true }} fullWidth sx={{ mt: 1 }} disabled /> */}
       </Card>
          <Card sx={{ mt: 2, p: 2 }}>
        {/* <FormControl>
          <FormLabel sx={{fontSize:"14px", fontWeight:"600"}}>Ship To: - </FormLabel>
          <RadioGroup
            value={shippingAddress}
            onChange={(e) => setShippingAddress(e.target.value)}
          >
            {shippingOptions.map((option) => (
              <FormControlLabel key={option} value={option} control={<Radio />} label={option} />
            ))}
          </RadioGroup>
        </FormControl> */}
        <FormControl sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
  <FormLabel sx={{ fontSize: "14px", fontWeight: 600, mr: 2, color:"#000" }}>
    Ship To: -
  </FormLabel>

  <RadioGroup
    row
    value={shippingAddress}
    onChange={(e) => setShippingAddress(e.target.value)}
  >
    {shippingOptions.map((option) => (
      <FormControlLabel
        key={option}
        value={option}
        control={<Radio size="small" />}
        label={option}
      />
    ))}
  </RadioGroup>
</FormControl>
 <TextField label="Address" value={shippingAddress.trim().toLowerCase()=="distributor"&&  (distributorType!='onboarded' && payload?.partyType !=  "P6E9TGXewd") ? form?.preferredDistributorAddress:contactData[shippingAddress]['address'] || ""} variant="outlined"  InputLabelProps={{ shrink: true }}  fullWidth sx={{ mt: 1 }} disabled />
        {/* <TextField
          label="Address"
          value={getDisplayAddressValue(shippingAddress)}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          fullWidth
          sx={{ mt: 1 }}
          disabled
        /> */}
       </Card>

          {/* <div style={{display:"flex", justifyContent:"center"}}>
         <FormControlLabel
       sx={{color:"#000", fontSize:"15px", fontWeight:"600"}}
          control={
            <Checkbox
              checked={isDiscountAdjustment}
              onChange={(e) => setIsDiscountAdjustment(e.target.checked)}
            />
          }
          label="Discount Adjustment"
        />
      </div> */}
          {/* <FormControlLabel
            control={
              <Checkbox
                checked={isDiscountAdjustment}
                onChange={(e) => setIsDiscountAdjustment(e.target.checked)}
                sx={{
                  color: "#586b7fff",
                  "&.Mui-checked": {
                    color: "#1976d2",
                  },
                }}
              />
            }
            label="Discount Adjustment"
            sx={{
              // border: "1px solid #566676ff",
              borderRadius: "8px",
              px: 2,
              py: 0.8,
              ml: 0,
              backgroundColor: isDiscountAdjustment ? "#e3f2fd" : "#fff",
              cursor: "pointer",
              userSelect: "none",
              width: "100%",
              fontWeight: 600,
              fontSize: "14px",
              color: "#000",
              transition: "all 0.25s ease",
              "&:hover": {
                backgroundColor: "#f5f9ff",
              },
            }}
          />

          {isDiscountAdjustment && (
            <Button
              variant="outlined"
              startIcon={<Add />}
              sx={{
                mt: 1.5,
                borderColor: "#000",
                color: "#000",
                fontWeight: 600,
                textTransform: "none",
                "&:hover": {
                  borderColor: "#000",
                  backgroundColor: "#f5f5f5",
                },
              }}
              onClick={() => handleAdditionalDiscount()}
            >
              Discount Adjustment
            </Button>
          )} */}

          { payload?.orderProcess != "upload" && <Card sx={{ mt: 2, p: 2, width: '100%' }}>
            <FormLabel sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>Upload Attachments</FormLabel>
            <input type="file" multiple onChange={handleFileChange} />
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
              <DialogTitle>File Preview</DialogTitle>
              <DialogContent>
                <Grid container spacing={2}>
                  {files.map((file, index) => (
                    <Grid item xs={6} key={index}>
                      {getFilePreview(file)}
                      <Typography variant="body2" noWrap>{file.name}</Typography>
                    </Grid>
                  ))}
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
                <Button onClick={handleUpload} variant="contained" color="primary">Upload</Button>
              </DialogActions>
            </Dialog>
          </Card>}
          {editMode && payload?.orderProcess != "upload" && <Grid container spacing={3} sx={{ mt: 1 }}>
                {parsedAttachments && parsedAttachments?.map((file, index) => {
                  const isImage = /\.(jpg|jpeg|png|gif)$/i.test(file.fileName);
                  const isPDF = /\.pdf$/i.test(file.fileName);

                  return (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <Card
                        elevation={3}
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          borderRadius: 2,
                        }}
                      >
                        {/* Preview */}
                        <Box
                          sx={{
                            height: 160,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#f5f5f5",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            isPDF ? handlePdfClick(file) : handleImageClick(file)
                          }
                        >
                          {isImage ? (
                            <img
                              src={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                              alt={file.originalName}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <InsertDriveFileIcon sx={{ fontSize: 60, color: "#666" }} />
                          )}
                        </Box>

                        {/* File Info */}
                        <CardContent sx={{ p: 1.5 }}>
                          <Typography
                            variant="body2"
                            title={file.originalName}
                            sx={{
                              fontWeight: 500,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {file.originalName}
                          </Typography>
                        </CardContent>

                        {/* Actions */}
                        <Box sx={{ p: 1.5, pt: 0 }}>
                          <Button
                            fullWidth
                            size="small"
                            variant="outlined"
                            onClick={(e) => {
                              e.stopPropagation();
                              downloadFile(file);
                            }}
                          >
                            Download
                          </Button>
                        </Box>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>}
          {/* <FormControl fullWidth className="my-2">
            <InputLabel>{"Select Stockist"}</InputLabel>
            <Select value={stockist} label={"Select Stockist"} onChange={(e) => selectStockist(e.target.value)}>
              {stockists.map((option, i) => (
                <MenuItem key={i} value={option?.stockistID}>{option?.StockistName}</MenuItem>
              ))}
            </Select>
          </FormControl> */}
          
          {editMode && stockist && (payload?.totalAmount > 0) &&  <Card sx={{ mb: 2, p: 2, backgroundColor: "#f9f9f9" }}>
            {/* <Typography fontWeight={600}>
              Stockist Discount (on Total Price {payload?.totalAmount || ""})
            </Typography> */}

            {/* <TextField
              type="number"
              label="Stockist Discount (%)"
              value={stockistDiscount}
              onChange={(e) => {
                let val = Number(e.target.value) || 0;

                if (val < 0) val = 0;
                if (val > 100) val = 100;

                setStockistDiscount(val);
              }}
              inputProps={{ min: 0, max: 100 }}
              fullWidth
              sx={{ mt: 1 }}
              helperText={getStockistHelperText()}
            /> */}
            {/* <TextField
              type="number"
              label="Stockist Discount (%)"
              value={stockistDiscount}
              onChange={(e) => {
                let val = Number(e.target.value) || 0;

                if (val < 0) val = 0;
                if (val > 100) val = 100;

                setStockistDiscount(val);
              }}
              inputProps={{ min: 0, max: 100 }}
              fullWidth
              sx={{
                mt: 1,
                "& .MuiFormHelperText-root": {
                  color: "#000", // ✅ helper text black
                  fontWeight: 500,
                },
              }}
              helperText={getStockistHelperText()}
            /> */}

            {/* Discounted price */}
            {((payload.totalAmount * stockistDiscount) / 100) > 0 && (
              <Typography
                variant="body2"
                sx={{
                  mt: 0.5,
                  color: "green", // ✅ discounted price green
                  fontWeight: 600,
                }}
              >
                Discounted Price: ₹{(payload.totalAmount * stockistDiscount) / 100}
                {/* Discounted Price: ₹{discountedPrice} */}
              </Typography>
            )}

          </Card>}
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Select Remark</InputLabel>
            <Select value={remark} label="Select Remark" onChange={(e) => setRemark(e.target.value)}>
              { }
              {
                remarks && remarks.map((r) => (
                  <MenuItem key={r.id} value={r.name}>{r?.name}</MenuItem>

                ))}
            </Select>
          </FormControl>
          <TextField
            label="Order Remark"
            fullWidth
            sx={{ mt: 2 }}
            value={orderRemark}
            onChange={(e) => setOrderRemark(e.target.value)}
          />
          {/* <TextField
            label="Delivery Date"
            type="date"
            fullWidth
            sx={{ mt: 2 }}
            value={specimenDate}
            onChange={(e) => setSpecimenDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          /> */}
          <TextField
  label="Delivery Date"
  type="date"
  fullWidth
  sx={{ mt: 2 }}
  value={specimenDate}
  onChange={(e) => setSpecimenDate(e.target.value)}
  InputLabelProps={{ shrink: true }}
  inputProps={{
    min: getTomorrowDate(),   // disables today & past dates
  }}
/>
{user?.role.includes('admin') && <TextField
  label=" Admin Order Date "
  type="date"
  fullWidth
  sx={{ mt: 2 }}
  value={adminDate}
  onChange={(e) => setAdminDate(e.target.value)}
  InputLabelProps={{ shrink: true }}
  inputProps={{
    max: new Date().toISOString().split("T")[0]
  }}
/>}
          {editMode && <TextField
            label="Update Remark"
            fullWidth
            sx={{ mt: 2 }}
            value={updateRemark}
            onChange={(e) => setUpdateRemark(e.target.value)}
          />}
          {/* {!editMode&&<Card sx={{ mt: 2, p: 2 }}>
        <FormControl>
          <FormLabel>Consent Person</FormLabel>
          <RadioGroup
            value={consentPerson}
            onChange={(e) => setConsentPerson(e.target.value)}
          >
            {consentPersons.map((p) => (
              <FormControlLabel key={p} value={p} control={<Radio />} label={p} />
            ))}
          </RadioGroup>
        </FormControl>
      </Card>} */}
        </Box>
      )}

      <Card sx={{ p: 2, mt: 2, backgroundColor: "#f5f5f5" }}>
        <FormControlLabel
          control={
            <Checkbox
            disabled={editData?.otp_need == "1"}
              checked={isVerified}
              onChange={(e) => setIsVerified(e.target.checked)}
            />
          }
          label= {editData?.otp_need == "1" ? "Verified" : "Verify with code"}
        />
        {isVerified && editData?.otp_need != "1" && (
          <Box sx={{ mt: 2, pt: 2, borderTop: "1px solid #ddd" }}>
            {/* <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Choose Contact Person</InputLabel>
              <Select
                value={specimenContactPerson}
                label="Choose Contact Person"
                onChange={(e) => setSpecimenContactPerson(e.target.value)}
              >
                <MenuItem key={""} value={""}>Select Contact Person</MenuItem>
                {consentPersons.map((p) => (
                  <MenuItem key={p} value={p}>{p}</MenuItem>
                ))}
              </Select>
            </FormControl> */}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Choose Contact Person</InputLabel>
              <Select
                value={specimenContactPerson}
                label="Choose Contact Person"
                onChange={(e) => setSpecimenContactPerson(e.target.value)}
              >
                <MenuItem value="">Select Contact Person</MenuItem>
                {consentPersons.map((p) => (
                  <MenuItem key={p} value={p}>{p}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <Card sx={{ p: 2, backgroundColor: "#fff", border: "1px solid #e0e0e0" }}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                Send message to:
              </Typography>
              <FormControl component="fieldset">
                <RadioGroup
                  value={specimenMessageOption}
                  onChange={(e) => setSpecimenMessageOption(e.target.value)}
                >
                  <FormControlLabel
                    value="registered"
                    control={<Radio />}
                    label="Registered number"
                  />
                  <FormControlLabel
                    value="other"
                    control={<Radio />}
                    label="Other"
                  />
                </RadioGroup>
              </FormControl>
              {specimenMessageOption === "other" && (
                <TextField
                  label="Enter Phone Number"
                  fullWidth
                  sx={{ mt: 2 }}
                  value={otherMobile}
                  onChange={(e) => setOtherMobile(e.target.value)}
                />
              )}
            </Card>
          </Box>
        )}
      </Card>
      {/* <Button variant="contained" sx={{ mt: 3 }} fullWidth
        disabled={isVerified && (!specimenContactPerson || (specimenMessageOption === "other" && otherMobile.trim() === ""))}
        // disabled={isVerified && !specimenContactPerson}
        onClick={() => proceedToOrder(false)}
      >
        Place Order
      </Button> */}
      <Button
        variant="contained"
        sx={{ mt: 3 }}
        fullWidth
        disabled={
          editData?.otp_need != "1" && isVerified &&
          (
            (specimenMessageOption.toLowerCase() === "other" && otherMobile.trim() === "") ||
            (specimenMessageOption.toLowerCase() != "other" && (!specimenContactPerson || specimenContactPerson.trim() == ""))
          )
        }
        onClick={() => proceedToOrder(false)}
      >
        Place Order
      </Button>

      {!editMode && <Button variant="contained" sx={{ mt: 3 }} fullWidth onClick={() => proceedToOrder(true)}>
        Save For Later
      </Button>}
      <Dialog open={otpOpen} onClose={() => setOtpOpen(false)}>
        <DialogTitle>Enter OTP</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="OTP" value={otp} onChange={(e) => setOtp(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOtpOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={verifyOtp}>Submit</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSeriesDiscount}
        onClose={() => setOpenSeriesDiscount(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Series Wise Additional Discount</DialogTitle>

        <DialogContent>
          {seriesDiscountData.map(item => (
            <Card key={item.seriesId} sx={{ mb: 2, p: 2 }}>
              <Typography fontWeight={600}>
                {item.seriesName}
              </Typography>

              <Typography variant="body2">
                Already Given: {item.alreadyGiven}%
              </Typography>

              <Typography variant="body2" color="success.main">
                Remaining: {item.remaining}% (Max {item.maxAllowed}%)
              </Typography>

              <TextField
                type="number"
                label="Additional Discount (%)"
                value={item.additional}
                onChange={(e) =>
                  handleSeriesDiscountChange(item.seriesId, e.target.value)
                }
                inputProps={{ min: 0, max: item.remaining }}
                fullWidth
                sx={{ mt: 1 }}
                disabled={item.remaining === 0}
              />
            </Card>
          ))}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenSeriesDiscount(false)}>Cancel</Button>
          <Button variant="contained" onClick={applyAdditionalDiscount}>
            Apply Discount
          </Button>
        </DialogActions>
      </Dialog>

    </Box>

  );
};
export default OrderForm;